//路由文件
import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "page" */ '../pages/login.vue'),
    },
    {
      path: '/app_downLoad',
      component: () => import(/* webpackChunkName: "downLoad" */ '../pages/app_downLoad/index.vue'),
      meta: {
        title: '下载'
      }
    },
    {
      path: '/verification',
      component: () => import(/* webpackChunkName: "firstBlock" */ '../pages/verification.vue')
    },
    {
      path: '/qr_code',
      component: () => import(/* webpackChunkName: "firstBlock" */ '../pages/qr_code.vue')
    },
    {
      path: '/retrieve',
      component: () => import(/* webpackChunkName: "firstBlock" */ '../pages/retrieve.vue')
    },
    {
      path: '/first',
      component: () => import(/* webpackChunkName: "page" */ '../pages/first.vue'),
    },

    {
      path: '/data',
      component: () => import(/* webpackChunkName: "page" */ '../pages/index.vue'),
      children: [

        {
          path: '/org',
          component: () => import(/* webpackChunkName: "page" */ '../pages/organizition/org.vue'),
        },
        {
          path: '/per',
          component: () => import(/* webpackChunkName: "page" */ '../pages/people/person.vue'),
        },
        {
          path: '/app',
          component: () => import(/* webpackChunkName: "page" */ '../pages/app/ddbes_app.vue'),
          children: [{
            path: '/t',
            component: () => import(/* webpackChunkName: "page" */ '../pages/app/dd_point.vue'),
          }, {
            path: '/task',
            component: () => import(/* webpackChunkName: "page" */ '../pages/app/dd_task.vue'),
          }, {
            path: '/c',
            component: () => import(/* webpackChunkName: "page" */ '../pages/app/dd_check.vue'),
          }, {
            path: '/i',
            component: () => import(/* webpackChunkName: "page" */ '../pages/app/dd_im.vue'),
          }, {
            path: '/v',
            component: () => import(/* webpackChunkName: "page" */ '../pages/app/dd_vote.vue'),
          },]
        },
        {
          path: '/pan',
          component: () => import(/* webpackChunkName: "page" */ '../pages/pan/pan.vue'),
        },
        {
          path: '/assets',
          component: () => import(/* webpackChunkName: "page" */ '../pages/assets/index.vue'),
        },
        {
          path: '/short',
          component: () => import(/* webpackChunkName: "page" */ '../pages/short/index.vue'),
        },
        {
          path: '/org_table',
          component: () => import(/* webpackChunkName: "page" */ '../pages/orgTable/orgTable.vue'),
          // chilldren: [{
          //   path: '/d',
          //   component: () => import(/* webpackChunkName: "page" */ '../pages/orgTable/detail.vue'),
          // }]
        },
        {
          path: '/tools',
          component: () => import(/* webpackChunkName: "page" */ '../pages/tools/index.vue'),
        },
        {
          path: '/tools_f',
          component: () => import(/* webpackChunkName: "page" */ '../pages/tools/tool_first.vue'),
        },
        {
          path: '/tools_app',
          component: () => import(/* webpackChunkName: "page" */ '../pages/tools/tools_app/index.vue'),
        },
        {
          name: 'ver_detail',
          path: '/ver_detail',
          component: () => import(/* webpackChunkName: "page" */ '../pages/tools/tools_app/ver_detail.vue'),
        },
        {
          name: 'create',
          path: '/create',
          component: () => import(/* webpackChunkName: "page" */ '../pages/tools/tools_app/create.vue'),
        },
        {
          path: '/user_table',
          component: () => import(/* webpackChunkName: "page" */ '../pages/userTable/userTable.vue'),
        },
        {
          path: '/publish',
          component: () => import(/* webpackChunkName: "page" */ '../pages/develop/publish/index.vue'),
        },
        {
          path: '/banner',
          component: () => import(/* webpackChunkName: "page" */ '../pages/develop/banner/index.vue'),
        },
        {
          path: '/admin',
          component: () => import(/* webpackChunkName: "voteBlock" */ '../pages/setAdmin/setAdmin.vue'),
        },
        {
          path: '/actor',
          component: () => import(/* webpackChunkName: "voteBlock" */ '../pages/actor/actor.vue'),
        },
        {
          path: '/goodsManage',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/shopManage/goodsManage.vue'),
        },
        {
          path: '/goodsPool',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/shopManage/goodsPool.vue'),
        },
        {
          path: '/shopHome',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/shopManage/home.vue'),
        },
        {
          path: '/addGood',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/shopManage/addGood.vue'),
        },
        {
          path: '/transactionManage',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/shopManage/transactionManage.vue'),
        },
        {
          path: '/billReview',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/shopManage/billReview.vue'),
        },
        {
          path: '/drawBill',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/shopManage/drawBill.vue'),
        },
        {
          path: '/drawBillOver',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/shopManage/drawBillOver.vue'),
        },
        {
          path: '/orderList',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/shopManage/orderList.vue'),
        },
        {
          path: '/orderDetail',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/shopManage/orderDetail.vue'),
        },
        {
          path: '/corporateTransfer',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/shopManage/corporateTransfer.vue'),
        },
        {
          path: '/waitDeliverGoods',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/shopManage/waitDeliverGoods.vue'),
        },
        {
          path: '/certification',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/certification/index.vue'),
        },
        {
          path: '/certificationSuccess',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/certification/success.vue'),
        },
        {
          path: '/certificationFail',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/certification/fail.vue'),
        },
        {
          path: '/certificationCancel',
          component: () => import(/* webpackChunkName: "shopManage" */ '../pages/certification/cancel.vue'),
        },
        {
          path:'/feedBack',
          component: () => import('../pages/feedBack/index.vue')
        },
        {
          path:'/feedBackDetail',
          component: () => import('../pages/feedBack/detail.vue')
        }
      ],
      redirect: '/first'
    }
  ],

});
// router.beforeEach((to, from, next) => {
//   //判断cookie是由有token
// })
export default router
